import React from 'react';
import { motion } from 'framer-motion';
import CountUp from './CountUp';

const Skill = ({ skill }) => {
  const numericLevel = parseInt(skill.level, 10);

  return (
    <div className="skill-item">
      <div className="skill-header">
        <div className="skill-info">
          <img src={skill.icon} alt={skill.name} className="skill-icon" />
          <span className="skill-name">{skill.name}</span>
        </div>
        <div className="skill-percentage">
          <CountUp to={numericLevel} duration={1.5} />%
        </div>
      </div>
      <div className="skill-level-container">
        <motion.div
          className="skill-level-bar"
          initial={{ width: 0 }}
          whileInView={{ width: skill.level }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
          role="progressbar"
          aria-valuenow={numericLevel}
          aria-valuemin="0"
          aria-valuemax="100"
          aria-label={`${skill.name} proficiency`}
        ></motion.div>
      </div>
    </div>
  );
};

export default Skill;